import React, { useState,useEffect } from "react";

import {
	Checkbox,
	IconButton,
	ListItemText,
	Menu,
	Tooltip,
} from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";


async function getIcon(name) {
	switch (name) {
		case "LocalOffer":
			return (await import("@material-ui/icons/LocalOffer")).default;
		case "AccountTreeOutlinedIcon":
			return (await import("@material-ui/icons/AccountTreeOutlined")).default
		case "ChatBubble":
			return (await import("@material-ui/icons/ChatBubble")).default
		// case "":
		// 	return (await import("@material-ui/icons/")).default
		default:
			return null;
	}
}

export default function TicketsQueueSelect({
	listItens,
	selected = [],
	setSelected,
	title,
	iconExib = ""
}) {
	const [anchorEl, setAnchorEl] = useState(null);
	const [Icon, setIcon] = useState(null);

	const darkMode = localStorage.getItem("darkMode") === "true" ? true : false;

	const handleOpenMenu = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleCloseMenu = () => {
		setAnchorEl(null);
	};

	useEffect(() => {
		async function loadIcon() {
			const Component = await getIcon(iconExib);
			setIcon(() => Component);
		}

		loadIcon();
	}, []);

	return (
		<div style={{ marginTop: -22 }}>
			<FormControl fullWidth margin="dense">
				<Tooltip title={title}>
					<IconButton
						style={{
							padding: 0,
							marginTop: "14px",
							color: `${darkMode ? "#c7c7c7" : "#6e6f70"}`,
						}}
						aria-controls="select-menu"
						aria-haspopup="true"
						onClick={handleOpenMenu}
					>
						{Icon && <Icon />}
					</IconButton>
				</Tooltip>
				<Menu
					id="select-menu"
					anchorEl={anchorEl}
					keepMounted
					open={Boolean(anchorEl)}
					onClose={handleCloseMenu}
					getContentAnchorEl={null}
					anchorOrigin={{
						vertical: "bottom",
						horizontal: "left",
					}}
					transformOrigin={{
						vertical: "top",
						horizontal: "left",
					}}
				>
					{listItens?.length > 0 &&
						listItens.map((item) => (
							<MenuItem dense key={item.id} value={item.id}>
								<Checkbox
									style={{
										color: item.color,
									}}
									size="small"
									color="primary"
									checked={Array.isArray(item.id)
										? selected.indexOf(item.id[0])  > -1
										: selected.indexOf(item.id) > -1
									}
									onClick={() => {
										if (Array.isArray(item.id)) {
											if (selected.indexOf(item.id[0]) > -1) {
												setSelected(prev =>
													prev.filter(id => !item.id.includes(id))
												);
											} else {
												setSelected(prev => [
													...prev,
													...item.id
												]);
											}
										} else {
											if (selected.indexOf(item.id) > -1) {
												setSelected(selected.filter((id) => id !== item.id))
											} else {
												setSelected([...selected, item.id])
											}
										}
									}}
								/>
								<ListItemText primary={item.name} />
							</MenuItem>
						))}
				</Menu>
			</FormControl>
		</div>
	);
}
